import { render, staticRenderFns } from "./vendor-details-flyout.vue?vue&type=template&id=4c808df3&scoped=true&"
import script from "./vendor-details-flyout.vue?vue&type=script&lang=js&"
export * from "./vendor-details-flyout.vue?vue&type=script&lang=js&"
import style0 from "./vendor-details-flyout.vue?vue&type=style&index=0&id=4c808df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c808df3",
  null
  
)

export default component.exports